// identificationConfig.js - Centralized configuration for identification document validation
export const IDENTIFICATION_REQUIRED_FIELDS = {
    national_passport: false,
    national_passport_expiry_date: false,
    drivers_license: false,
    drivers_license_expiry_date: false,
    diplomatic_card: false,
    diplomatic_card_expiry_date: false,
    national_id_card: false,  // Single source of truth
    national_id_card_expiry_date: false,
    unlp: false,
    unlp_expiry_date: false,
    expiration_date: false
};

// Conditional validation rules: if ID is provided, expiry date is required
export const IDENTIFICATION_CONDITIONAL_RULES = {
    national_passport: 'national_passport_expiry_date',
    drivers_license: 'drivers_license_expiry_date',
    diplomatic_card: 'diplomatic_card_expiry_date',
    national_id_card: 'national_id_card_expiry_date',
    unlp: 'unlp_expiry_date'
};

// List of all form fields for percentage calculation
export const IDENTIFICATION_FORM_FIELDS = [
    'national_passport',
    'national_passport_expiry_date',
    'drivers_license',
    'drivers_license_expiry_date',
    'diplomatic_card',
    'diplomatic_card_expiry_date',
    'national_id_card',
    'national_id_card_expiry_date',
    'unlp',
    'unlp_expiry_date',
    'country_of_issue',
    'issue_date',
];

// Default values for form initialization
export const IDENTIFICATION_DEFAULT_VALUES = {
    national_passport: '',
    national_passport_expiry_date: '',
    drivers_license: '',
    drivers_license_expiry_date: '',
    diplomatic_card: '',
    diplomatic_card_expiry_date: '',
    national_id_card: '',
    national_id_card_expiry_date: '',
    unlp: '',
    unlp_expiry_date: '',
    country_of_issue: '',
    issue_date: '',
};